import { render } from "./OnlineConfirmPage.vue?vue&type=template&id=5a694a81&scoped=true&ts=true"
import script from "./OnlineConfirmPage.vue?vue&type=script&lang=ts"
export * from "./OnlineConfirmPage.vue?vue&type=script&lang=ts"

import "./OnlineConfirmPage.vue?vue&type=style&index=0&id=5a694a81&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a694a81"]])

export default __exports__